import controller from './reauth.controller';
import template from './reauth.pug';

const ReauthComponent = {
  template,
  controller,
};

export default ReauthComponent;



// WEBPACK FOOTER //
// ./client/components/auth/reauth/reauth.component.js